import OliverText from "@builder/components/general/OliverText";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";

const MotoAction = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [paymentDetails] = useState<any>(
        actionStep?.action?.data || {
            paymentName: "MOTO"
        }
    );
    const dispatch = useAppDispatch();

    useEffect(() => {
        const action = {
            type: ActionType.MOTO,
            data: paymentDetails
        };

        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [paymentDetails, actionStep, dispatch, id]);

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper">
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="MOTO Payment" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText
                            text="This will process the payment using MOTO (Mail Order/Telephone Order)"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={true} label="" value="" custom={false} />
                </div>
            </div>
        </div>
    );
};

export default MotoAction;
